import React from "react";
import Create from "modules/roles/components/Create";

const RolesCreatePage = () => {
  return <Create />;
};

export default RolesCreatePage;
